import { DateTime } from 'luxon';

export const TASK_COUNTS_BY_STATUS_QUERY_KEY_ROOT = 'taskCountsByStatus';

export const TASKS_AFTER_DATETIME = DateTime.now().minus({ days: 7 }).toISO() ?? undefined;
